import { render, staticRenderFns } from "./SchoolTypeTabs.vue?vue&type=template&id=04611b7a&"
import script from "./SchoolTypeTabs.vue?vue&type=script&lang=js&"
export * from "./SchoolTypeTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports